module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div class="'+(props.styles.liveIndicator)+' '+(props.styles.hidden)+'"> <button tabindex="0" class="'+(props.styles.liveIndicatorButton)+'" aria-label="'+(props.texts.label || '')+'" data-playable-hook="live-indicator-button"> '+(props.texts.text || '')+' </button></div>';return out;
} 
  };